import React, { useEffect } from 'react';
import { SeoBar } from '../components/SeoBar';
import { Header } from '../components/Header';
import { Footer } from '../components/Footer';
import { HeroSection } from './bodor-plate-cutting/HeroSection';
import { IntroSection } from './bodor-plate-cutting/IntroSection';
import { HighPowerSection } from './bodor-plate-cutting/HighPowerSection';
import { CSeriesSection } from './bodor-plate-cutting/CSeriesSection';
import { PSeriesSection } from './bodor-plate-cutting/PSeriesSection';
import { ISeriesSection } from './bodor-plate-cutting/ISeriesSection';
import { I3SeriesSection } from './bodor-plate-cutting/I3SeriesSection';
import { C3TSeriesSection } from './bodor-plate-cutting/C3TSeriesSection';
export function BodorPlateCuttingPage() {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);
  return <div className="min-h-screen w-full bg-white flex flex-col" data-id="element-1043">
      <SeoBar data-id="element-1044" />
      <Header data-id="element-1045" />
      <main className="flex-grow" data-id="element-1046">
        <div className="w-full bg-white pb-20" data-id="element-1047">
          <HeroSection data-id="element-1048" />
          <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12" data-id="element-1049">
            <IntroSection data-id="element-1050" />
            <HighPowerSection data-id="element-1051" />
            <div className="space-y-20" data-id="element-1052">
              <CSeriesSection data-id="element-1053" />
              <PSeriesSection data-id="element-1054" />
              <ISeriesSection data-id="element-1055" />
              <I3SeriesSection data-id="element-1056" />
              <C3TSeriesSection data-id="element-1057" />
            </div>
          </div>
        </div>
      </main>
      <Footer data-id="element-1058" />
    </div>;
}